<template>
  <ContainerView class="h-full w-full bg-gray-100 p-6 lg:p-10">
    <LoadingControl v-show="loading" :loading="loading" :z_value="'z-50'" />
    <!-- <ModalControl v-show="this.show_poll_modal" v-bind:display="this.show_poll_modal" :z_value="'z-50'"
      v-bind:title="lang('amendments.title')" @closed="closedPoll" @positiveClick="handlePollVote"
      @readAmendments="showAmendments" :positiveButton="lang('submit')" :amendment="lang('view.amendments')"
      :default_width="'max-w-4xl'" :default_height="'h-[70vh] lg:h-[85vh] xl:h-[75vh] 2xl:h-[85vh]'" id='vote_modal'
      ref='pollModal' closable>
      <div class="w-full flex flex-col justify-start text-left">
        <img src="https://resource.pafcpic.net/assets/papsi/papsi_logo.png" class="w-1/5 mb-2 pt-6 text-left" />
        <h2 class="text-2xl font-bold text-theme-primary mb-5 text-left">Proposed Amendments</h2>
      </div>
      <div class="w-full p-5 flex flex-col bg-gray-100 rounded-2xl shadow-sm text-[0.85rem] text-justify">
        <span class="leading-6" v-text="lang('letter.greetings')" />
        <span class="mb-2 leading-6" v-text="lang('letter.first.para')" />
        <a href="https://resource.pafcpic.net/assets/referendum/ACBL_2025.pdf" target="_blank" rel="noopener"
          class="text-theme-primary font-bold hover:underline">
          {{ lang('view.amendments') }}
        </a>
        <span class="font-bold mt-2 leading-6" v-text="lang('letter.second.para')" />
        <span class="leading-6 mt-2" v-text="lang('letter.casting.vote')" />
        <span class="leading-6 mt-2" v-text="lang('Very truly yours,')" />
        <img src="https://resource.pafcpic.net/assets/referendum/chairman_signature.png" class="w-[100px] -mb-5" />
        <span class=" font-bold" v-text="lang('BGEN FRANCISCO M PAREDES (RET)')" />
        <span class="-mt-2" v-text="lang('Chairperson of the Board')" />
        <div class="border-b border-dashed border-gray-400 w-full my-3" />
        <span class="leading-6" v-text="lang('letter.acknowledging.para')" />
      </div>
    </ModalControl> -->
    <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
      :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
      @positiveClick="handlePositiveClick()" :positiveButton="'OK'" :default_width="'max-w-xl'" id='vote_modal'>
      <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
        {{ this.modal_message }}
      </div>
    </ModalControl>
    <ModalControl v-show="show_confirm_modal" v-bind:display="show_confirm_modal" :question="true" z_value="z-50"
      @positiveClick="vote(selectedVote)" :positiveButton="'Yes'" @negativeClick="show_confirm_modal = false"
      :negativeButton="'No'" :default_width="'max-w-xl'" id='vote_modal'>
      <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
        <p>Are you sure you want to submit your vote? Once submitted, your vote cannot be changed or resubmitted.</p>
      </div>
    </ModalControl>
    <ModalControl v-show="show_confirm_register" v-bind:display="show_confirm_register" :question="true" z_value="z-50"
      @positiveClick="register()" :positiveButton="'Yes'" @negativeClick="show_confirm_register = false"
      :negativeButton="'No'" :default_width="'max-w-xl'" id='register_modal'>
      <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
        <p>Are you sure you want to register?</p>
      </div>
    </ModalControl>
    <ModalControl v-show="rating_modal" v-bind:display="rating_modal" z_value="z-50" :default_width="'max-w-xl'"
      id='vote_modal' closable>
      <RatingControl @close="rating_modal = false" />
    </ModalControl>
    <!-- <ModalControl v-show="schedule_modal" v-bind:display="schedule_modal" z_value="z-50" :default_width="'max-w-lg'"
      id='vote_modal' closable @closed="schedule_modal = false">
      <div class="w-full pt-6 flex flex-col text-xl justify-start text-left items-start">
        <h2 class="text-2xl font-bold text-theme-primary mb-5">Referendum Schedule</h2>
        <div class="w-full flex flex-col space-y-1 bg-green-50 rounded-2xl p-5 mb-5">
          <p class="text-lg font-semibold text-theme-primary">Voting Starts On</p>
          <p class="text-gray-600">{{ formatDate($store.state.sga_config.schedules.start_date) }}</p>
        </div>

        <div class="w-full flex flex-col space-y-1 bg-yellow-50 rounded-2xl p-5">
          <p class="text-lg font-semibold text-yellow-700">Voting Ends On</p>
          <p class="text-gray-600">{{ formatDate($store.state.sga_config.schedules.end_date) }}</p>
        </div>
      </div>
    </ModalControl> -->
    <ModalControl v-show="this.show_update" v-bind:display="this.show_update" @positiveClick="directSettings"
      :positiveButton="'Update'" :default_width="'max-w-lg'" id='show_update'
      v-bind="(!($store.state.credentials.mobile && $store.state.credentials.email)) ? {} : { negativeButton: 'Skip', onNegativeClick: skip }">
      <div class="pt-6">
        <h2 class="text-xl lg:text-2xl font-bold text-theme-primary mb-2 text-left">Update your Information</h2>
        <p class="mb-4 lg:mb-5 text-left text-base">Upon checking our records, we noticed some of your information is
          missing. Please update your details to keep your account complete and up-to-date.</p>
      </div>

      <div class="flex flex-col text-gray-500 text-left w-full text-base justify-center items-center gap-3 mb-4">
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.email">
          <p>Email Address</p>
        </div>
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.mobile">
          <p>Mobile Number</p>

        </div>
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.birthdate">
          <p>Birthdate</p>

        </div>

        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.tin">
          <p>Taxpayer Identification Number (TIN)</p>

        </div>
      </div>
    </ModalControl>
    <ModalControl v-show="this.show_list" v-bind:display="this.show_list" @positiveClick="directSettings"
      :positiveButton="'Update'" :default_width="'max-w-lg'" id='show_update'
      v-bind="(!($store.state.credentials.mobile && $store.state.credentials.email)) ? {} : { negativeButton: 'Skip', onNegativeClick: skip }">
      <div class="pt-6">
        <h2 class="text-xl lg:text-2xl font-bold text-theme-primary mb-2 text-left">Update your Information</h2>
        <p class="mb-4 lg:mb-5 text-left text-base">Upon checking our records, we noticed some of your information is
          missing. Please update your details to keep your account complete and up-to-date.</p>
      </div>

      <div class="flex flex-col text-gray-500 text-left w-full text-base justify-center items-center gap-3 mb-4">
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.email">
          <p>Email Address</p>
        </div>
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.mobile">
          <p>Mobile Number</p>

        </div>
        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.birthdate">
          <p>Birthdate</p>

        </div>

        <div
          class="w-full flex flex-row gap-3 justify-between items-center bg-red-100 border-2 border-red-700 text-red-700 rounded-xl p-3"
          v-show="!$store.state.credentials.tin">
          <p>Taxpayer Identification Number (TIN)</p>

        </div>
      </div>
    </ModalControl>
    <ModalControl v-show="show_pin_modal" v-bind:display="show_pin_modal" z_value="z-40" closable @closed="handleLogout"
      id='pin_modal' :default_width="'max-w-lg'">
      <div class="pt-6">

        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
        <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to proceed.</p>

        <div class="w-full flex flex-row justify-center my-4">
          <v-otp-input :is-disabled="false" ref="pinOTP" input-classes="otp-input" :input-type="pin_type"
            inputmode="numeric" :num-inputs="6" v-model:value="pin_value" :should-auto-focus="true"
            :should-focus-order="true" :key="otpInputKey" @on-complete="validatePIN" @on-change="changePIN" />
          <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
            @click="togglePeeker()">
            <Icon :source="getImgSrc()" :width="24" />
          </div>
        </div>

        <div class="w-full flex items-center justify-center text-center pt-3 text-base">
          <p>Forgot your PIN? <span class="text-theme-primary font-bold hover:underline cursor-pointer"
              @click="requestOTPPIN">RESET</span></p>
        </div>

        <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
          <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
            v-text="pin_error_message" />
        </div>
      </div>
    </ModalControl>
    <ModalControl v-show="this.forgot_PIN" v-bind:display="this.forgot_PIN" z_value="z-40" :default_width="'max-w-xl'"
      id='forgot_modal' closable @closed="handleLogout">
      <div class="pt-6">
        <div class="w-full flex flex-col">
          <div class="" v-show="!show_con_pin">
            <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Enroll PIN</h2>
            <p class="mb-5 text-left text-base">For enhanced security, please create a unique Personal Identification
              Number (PIN) for future application logins.</p>

            <div class="flex flex-row w-full my-5 justify-center items-center align-center text-center">
              <v-otp-input ref="forgotOTP" input-classes="otp-input-register"
                :conditionalClass="['pin1', 'pin1', 'pin1', 'pin1', 'pin1', 'pin1']" separator=" "
                :input-type="input_type_pin" inputmode="numeric" :num-inputs="6" @on-change="changePIN"
                @on-complete="checkPinValidity" v-model:value="enroll_pin" :should-auto-focus="true"
                :should-focus-order="true" :key="otpInputKey" />
              <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                @click="togglePeekerEnroll">
                <Icon v-bind:source="getImgSrc()" :width="24" />
              </div>
            </div>

            <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center">
              <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                v-text="error_pin_message" />
            </div>
          </div>

          <div class=" text-left" v-show="show_con_pin">
            <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Confirm PIN</h2>
            <p class="mb-5 text-left text-base">Please re-type your Personal Identification Number (PIN) to confirm.</p>

            <div class="flex flex-row w-full my-5 justify-center items-center text-center">
              <v-otp-input ref="conOtpInput" input-classes="otp-input-register"
                :conditionalClass="['con1', 'con2', 'con3', 'con4', 'con5', 'con6']" separator=" "
                @on-change="changeConPIN" @on-complete="checkPinValidity" :inputType="input_type_con" :num-inputs="6"
                v-model:value="con_enroll_pin" :should-auto-focus="true" :should-focus-order="true"
                :key="otpInputKey" />
              <div class="otp-input-register flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                @click="togglePeekerCon">
                <Icon v-bind:source="getImgSrcCon()" :width="24" />
              </div>

            </div>

            <div v-show="error_pin_message" class="w-full flex items-center justify-center text-center mb-4">
              <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                v-text="error_pin_message" />
            </div>

            <div class="flex flex-row space-x-3 justify-center mt-2">
              <Button @clicked="backToPin" is_secondary rounded :button_text="lang('BACK')" />
            </div>

          </div>
        </div>
      </div>

    </ModalControl>
    <ModalControl v-show="this.show_otp_modal" v-bind:display="this.show_otp_modal" z_value="z-40"
      :default_width="'max-w-xl'" id='otp_modal' closable @closed="handleLogout">
      <div class="pt-6">

        <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">OTP Verification</h2>
        <p class="mb-5 text-base text-left">Please enter the One-Time Password (OTP) we have sent to your Email Address
          or Mobile Number to proceed.
        </p>

        <div class="pb-2 w-full justify-items-center font-bold uppercase text-left p-2">
          <v-otp-input :is-disabled="false" ref="otp_input" input-classes="otp-input"
            :conditionalClass="['1', '2', '3', '4', '5', '6']" separator=" " :input-type="'number'" inputmode="numeric"
            :num-inputs="6" @on-complete="submitOTP" @on-change="changeOTP" v-model:value="otp"
            :should-auto-focus="true" :should-focus-order="true" :key="otpInputKey" />
        </div>

        <div class="flex flex-row gap-x-2 pt-3 w-full justify-center text-center text-gray-400 text-sm">
          <p>Didn't receive a code? <span v-show="!show_resend_otp" class="font-semibold">Resend in {{
            formattedTimer }}</span></p>
          <LinkText emit_triggered='resendOtp' @resendOtp="resendOtp" class="text-theme-primary font-bold" text="Resend"
            v-show="show_resend_otp" />
        </div>

        <!-- Error Message Display -->
        <div v-show="otp_error_message" class="w-full flex items-center justify-center text-center mt-4 rounded-full">
          <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
            v-text="otp_error_message" />
        </div>
      </div>
    </ModalControl>

    <!-- <AmendmentView :display="show_pdf" @closedAmendments="closedAmendments" /> -->

    <div class="w-full h-full">
      <h1 class="text-theme-primary text-3xl font-semibold">Dashboard</h1>
      <div class="w-full grid grid-cols-1 justify-start align-top mt-5 gap-10">
       <div
          class="lg:col-span-2 mb-auto flex flex-col justify-center items-start p-4 lg:p-7 bg-white rounded-2xl shadow-sm overflow-clip pb-10">
          <div class="w-full">
            <!-- <div class="w-full flex flex-row justify-between items-center mb-5">
              <p class="w-fit px-3 py-1 text-gray-600 font-medium text-lg border-l-8 border-theme-secondary">PAFCPIC
                Services</p>
              <div @click="$router.push('/services/eft')"
                class="flex flex-row gap-2 bg-theme-primaryLight hover:bg-green-100 cursor-pointer items-center px-3 py-2 rounded-full text-theme-primary font-medium">
                <p class="hidden lg:block">More Details</p>
                <img src="@/assets/images/papsi_next_green.svg" class="w-4 h-4" />
              </div>
            </div> -->
            <!-- <img src="https://tinyurl.com/2u2t2wb6" class="w-full md:block rounded-xl" /> -->
            <!-- <img src="@/assets/images/banner_eft-2.png" class="w-full rounded-xl"> -->
            <SliderControl :slides="sliderItems"
            :autoSlideInterval="50" />

            <!-- <SkeletonControl v-show="!show_timer" class="mt-5" /> -->
            <!-- <div class="w-full flex flex-col mt-10" v-show="show_timer && !votingEnded">
              <div
                class="text-theme-primary text-lg leading-4 uppercase font-bold text-center italic items-center justify-center flex w-full mb-5">
                <p>- {{ label }} -</p>
              </div>
              <div class="w-full flex justify-center gap-2 flex-wrap md:flex-nowrap">
                <Tick :value="days.toString()" label="Days" margin />
                <Tick :value="hour.toString()" label="Hrs" margin />
                <Tick :value="minute.toString()" label="Mins" margin />
                <Tick :value="seconds.toString()" label="Secs" />
              </div>


              <div class="text-white text-center flex justify-center">
                <div class="w-full lg:max-w-[34rem] pt-5">
                  <Button class="text-lg md:text-xl lg:text-2xl uppercase" :button_text="button_text" @clicked="handleButton()" rounded
                    :disabled="button_visible || hasVoted || hasRegistered" />
                </div>
              </div>
            </div> -->
          </div>

        </div>
      </div>


    </div>
  </ContainerView>
</template>

<script>
import { defineComponent } from 'vue';
import ContainerView from '@/components/sections/ContainerView.vue';
import User from "@/services/User";
import Button from "@/components/controls/ButtonControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
// import AmendmentView from "@/components/sections/AmendmentView.vue";
import LoadingControl from "@/components/controls/LoadingControl.vue";
// import Tick from "@/components/controls/TickControl.vue";
import RatingControl from '@/components/controls/RatingControl.vue';
import SGA from "@/services/SGA";
import mixin from "@/mixin";
import OTP from "@/services/OTP";
import VOtpInput from "vue3-otp-input";
// import SkeletonControl from '@/components/controls/SkeletonControl.vue';
import LinkText from "@/components/controls/LinkText.vue";
import Icon from "@/components/controls/Icon.vue";
import SliderControl from "@/components/controls/SliderControl.vue";


export default defineComponent({
  components: {
    ContainerView,
    ModalControl,
    // AmendmentView,
    LoadingControl,
    // Tick,
    Button,
    Icon,
    // SkeletonControl,
    RatingControl,
    VOtpInput,
    LinkText,
    SliderControl
  },

  mounted() {
    const state = this.$store.state;

    if (!state.credentials.username) {
      this.getUserInfo();
    } else {
      this.checkUserFlow();
    }

    // this.getBanks();
  },
  data() {
    return {
      type: null,
      schedule_modal: false,
      hasVotedLocal: false,
      hasRegisteredLocal: false,
      show_poll_modal: false,
      show_list: false,
      show_message_modal: false,
      show_confirm_register: false,
      show_confirm_modal: false,
      referendum_modal: false,
      show_update: false,
      rating_modal: false,
      enroll_pin: '',
      error: false,
      question: false,
      server_time: '',
      success: false,
      warning: false,
      modal_message: '',
      expired: false,
      show_pdf: false,
      loading: false,
      mev: false,
      days: 0,
      hour: 0,
      ga_series: '',
      show_timer: true,
      minute: 0,
      seconds: 0,
      date_start: '',
      date_end: '',
      eligible: false,
      voted: false,
      started: false,
      ended: false,
      voting_ended: false,
      label: '',
      modal_type: 0,
      registration_start: '',
      registration_end: '',
      registration_ended: false,
      registration_started: false,
      election_registered: false,
      can_vote: false,
      button_text: '',
      button_disabled: false,
      button_visible: false,
      button_function: 0,
      show_menu: false,
      countdownInterval: null,
      referendum_voted: false,
      selectedVote: null,
      con_enroll_pin: '',
      enroll_pin_btn: false,
      enroll_conpin_btn: false,
      input_type_pin: 'password',
      input_type_con: 'password',
      username: '',
      password: '',
      show_resend_otp: false,
      timerCount: 0,
      timerEnabled: false,
      otpType: '',
      con_visible: false,
      otp: '',
      otpInputKey: 0,
      otp_pin: '',
      otp_token: '',
      pin_type: 'password',
      message: '',
      show: false,
      fade: false,
      error_message: false,
      show_help_modal: false,
      login_btn: true,
      name: '',
      pin_error_message: '',
      otp_error_message: '',
      pin_value: '',
      visible_pin: false,
      show_otp_modal: false,
      otp_payload: null,
      otpPIN: '',
      otpOTP: '',
      resettingPIN: false,
      forgot_PIN: false,
      show_con_pin: false,
      error_pin_message: '',
      show_pin_modal: false,
      sliderItems: [
        {
          backgroundImage: "https://resource.pafcpic.net/assets/funrun/papsi_run_2025.jpg",
          title: "PAPSI Run: #FortyFOURWARDofHOPE",
          subtitle: "Every Step Counts — Be a HERO to Our Heroes’ Children",
          buttonText: "View Event",
          // buttonLink: "http://localhost:8080/registration",
          buttonLink: "/events",
        },
        {
          backgroundImage: "https://resource.pafcpic.net/assets/eft/papsi_eft_banner.jpg",
          title: "Electronic Fund Transfer",
          subtitle: "Receive your PatRef/Dividend directly to your Bank Account for FREE!",
          buttonText: "More Details",
          buttonLink: "/services/eft",
        },
      ],
    }
  },
  mixins: [
    mixin,
  ],
  inject: ['setLoading'],
  watch: {
    'date_start': {
      handler(newVal) {
        if (newVal && this.date_end) {
          this.restartCountdown();
        }
      },
      immediate: true
    },
    'date_end': {
      handler(newVal) {
        if (newVal && this.date_start) {
          this.restartCountdown();
        }
      },
      immediate: true
    },
    timerCount: {
      handler(value) {
        let that = this;
        if (value > 0 && that.timerEnabled) {
          that.show_resend_otp = false;
          setTimeout(() => {
            that.timerCount = that.timerCount - 1;
          }, 1000);
        } else {
          that.show_resend_otp = true;
          that.timerEnabled = false;
        }
      },
      immediate: true
    },
  },
  computed: {
    hasRegistered() {
      return this.hasRegisteredLocal || this.$store.state.sga_config.has_registered;
    },
    hasVoted() {
      return this.hasVotedLocal || this.$store.state.sga_config.has_voted;
    },
    isEligible() {
      return this.$store.state.sga_config.eligible && this.$store.state.credentials.regular;
    },
    needsToRegister() {
      return this.$store.state.credentials.regular && !this.$store.state.sga_config.eligible;
    },
    votingEnded() {
      return this.$store.state.sga_config.schedules.has_ended;
    },
    hasPIN() {
      return this.$store.state.credentials.has_pin;
    },
    formattedTimer() {
      const min = Math.floor(this.timerCount / 60);
      const sec = this.timerCount % 60;
      return `${min}:${sec.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    handleButton() {
      if (this.needsToRegister) {
        this.show_confirm_register = true;
      } else {
        this.showPollModal();
      }
    },
    // register() {
    //   this.show_confirm_register = false;
    //   this.setLoading(true);
    //   let that = this;
    //   const key = this.$store.state.credentials.key;
    //   const cookie = that.$cookies;

    //   SGA.registerMember(cookie.get('user_session').hash, key)
    //     .then(() => {
    //       that.setLoading(false);
    //       that.success = true;
    //       that.warning = false;
    //       that.error = false;
    //       that.info = false;
    //       that.modal_message = "Thank you for registering for the Referendum!";
    //       that.hasRegisteredLocal = true;
    //       that.show_message_modal = true;
    //     }).catch((error) => {
    //       that.error = true;
    //       that.setLoading(false);
    //       that.show_message_modal = true;
    //       that.modal_message = error.response.data.message;
    //       if (error.response.status == 403) {
    //         that.expired = true
    //         that.modal_message = "Your session has expired. Please log in again.";
    //         that.$store.state.logged = false;
    //       }
    //     })
    // },
    checkUserFlow() {
      const that = this;
      const state = that.$store.state;
      const noContact = !state.credentials.mobile || !state.credentials.email;
      const config = state.credentials.config;
      const temporaryPIN = state.credentials.pin_update;
      const isValidated = that.$cookies.get('validated');

      // this.getGaInfo();

      if (state.credentials.deactivated) {
        this.$router.push('/user/settings');
        return;
      }

      if (noContact) {
        state.credentials.noContact = noContact;
        this.show_update = true;
        return;
      }

      if (state.credentials.enrolled_pin) {
        const hasValidConfig = config && config.status;
        const noContact = state.credentials.noContact;
        state.credentials.enrolled_pin = false;

        if (noContact) {
          that.show_update = false;
          that.show_pin_modal = false;
          that.show_otp_modal = false;
          that.$cookies.set('validated', true);
        } else {
          if (hasValidConfig) {
            that.requestOTP();
          } else {
            that.show_update = false;
            that.show_pin_modal = false;
            that.show_otp_modal = false;
            that.$cookies.set('validated', true);
          }
        }
        return;
      }


      if (!isValidated) {
        if (state.credentials.has_pin) {
          this.show_pin_modal = true;
        } else {
          this.$router.push('/user/settings');
        }
      }

      if (temporaryPIN) {
        this.$router.push('/user/settings');
        state.credentials.edit_temporary = true;
        return;
      }

      const missingInfo = !state.credentials.mobile || !state.credentials.email ||
        !state.credentials.tin || !state.credentials.birthdate;

      if (missingInfo && !that.$cookies.get('skipped')) {
        this.show_update = true;
      }
    },
    getUserInfo() {
      let that = this;
      const cookie = that.$cookies;
      const store = that.$store;
      let state = store.state;
      that.setLoading(true);

      User.recoverSession(cookie.get('user_session').hash).then(function (response) {
        let data = response.data.data;
        state.logged = true;
        state.credentials.first_name = data.info.first_name;
        state.credentials.last_name = data.info.last_name;
        state.credentials.middle_name = data.info.middle_name;
        state.credentials.regular = data.info.regular;
        state.credentials.express = data.express;
        state.credentials.pso_enroll = data.pso_enroll;
        state.credentials.pin_update = data.pin_update;
        state.credentials.membership_date = data.info.membership_date || null;
        state.credentials.status = data.status || null;
        state.credentials.account_no = data.info.account_number;
        state.credentials.email = data.info.email;
        state.credentials.gender = data.info.gender;
        state.credentials.birthdate = data.info.date_of_birth;
        state.credentials.age = data.info.age;
        state.credentials.membership_type = data.info.membership_type;
        state.credentials.registered_date = data.info.registered;
        state.credentials.key = data.key;
        state.credentials.mobile = data.info.mobile;
        state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
        state.credentials.suffix = data.info.suffix ?? '';
        state.credentials.qr = data.qr;
        state.credentials.uuid = data.uuid;
        state.credentials.serial_no = data.info.serial_number;
        state.credentials.timestamp = response.timestamp;
        state.credentials.username = data.info.username;
        state.credentials.hash = data.hash;
        state.credentials.has_pin = data.has_pin;
        state.credentials.deactivated = data.deactivated;
        state.credentials.tin = data.info.tin;
        const type2Config = data.config.find(item => item.type === 2);
        if (type2Config) {
          state.credentials.config = { status: type2Config.status };
        } else {
          state.credentials.config = null;
        }
        that.checkUserFlow();
        that.setLoading(false);

      }).catch(function (error) {
        that.error = true;
        that.setLoading(false);
        that.show_message_modal = true;
        that.modal_message = error.response.data.message;
        if (error.response.status == 403) {
          that.expired = true
          that.modal_message = "Your session has expired. Please log in again.";
          that.$store.state.logged = false;
        }
      });
    },
    checkPinValidity() {
      let that = this;

      const isSequential = (pin) => {
        return '1234567890'.includes(pin) || '0987654321'.includes(pin);
      };

      const isRepeated = (pin) => {
        return /^(\d)\1+$/.test(pin); // Matches all same digits (e.g., 111111)
      };

      // --- Validations ---
      if (that.enroll_pin === "") {
        that.error_pin_validity = true;
        that.error_pin_message = "Don't leave the PIN empty.";
        return;
      }

      if (that.enroll_pin.length < 6) {
        that.error_pin_validity = true;
        that.error_pin_message = 'PIN must be at least 6 digits.';
        return;
      }

      if (isSequential(that.enroll_pin) || isRepeated(that.enroll_pin)) {
        that.error_pin_validity = true;
        that.error_pin_message = 'PIN is too weak.';
        that.enroll_pin_btn = false;
        that.enroll_pin = '';
        that.otpInputKey++;
        return;
      }

      if (that.show_con_pin) {
        if (that.con_enroll_pin === "") {
          that.error_pin_validity = true;
          that.error_pin_message = "Don't leave the PIN empty.";

          return;
        }

        if (that.con_enroll_pin.length < 6) {
          that.error_pin_validity = true;
          that.error_pin_message = 'PIN must be at least 6 digits.';
          return;
        }

        if (that.enroll_pin !== that.con_enroll_pin) {
          that.error_pin_validity = true;
          that.error_pin_message = 'PINs do not match.';
          that.enroll_conpin_btn = false;
          that.con_enroll_pin = '';
          that.otpInputKey++;
          return;
        }

        that.error_pin_validity = false;
        that.setLoading(true);

        let payload = {
          hash: that.hash,
          otp_token: that.otp_token,
          otp_pin: that.otp_pin,
          pin: that.enroll_pin
        };
        const cookie = that.$cookies;

        User.forgotPIN(cookie.get('user').uuid, payload)
          .then(function () {
            that.setLoading(false);
            that.error = false;
            that.note = false;
            that.show_pin_modal = false;
            that.forgot_PIN = false;
            that.success = true;
            that.modal_message = 'Congratulations! You have successfully updated your Personal Identification Number (PIN).';
            that.show_message_modal = true;
            that.$cookies.set('validated', true);
          })
          .catch(function (error) {
            that.note_style = "text-center";
            that.setLoading(false);
            that.$refs.conOtpInput?.clearInput();
            that.$refs.otpInput?.clearInput();
            that.backToPin();
            that.error = true;
            that.show_message_modal = true;
            that.modal_message = error.response?.data?.message || 'Something went wrong';
          });

      } else {
        that.error_pin_validity = false;
        that.show_con_pin = true;
        that.show_negative_button = "Back";
        that.modal_button_text = "Submit";
      }
    },
    changePIN() {
      this.error_pin_message = ''
      this.enroll_conpin_btn = false;
      this.pin_error_message = '';
    },
    changeConPIN() {
      this.error_pin_message = '';
      this.enroll_conpin_btn = false;
    },
    backToPin() {
      this.show_con_pin = false;
      this.error_pin_validity = false;
      this.show_negative_button = null;
      this.error_pin_message = '';
      this.modal_button_text = "Next";
    },
    togglePeekerEnroll() {
      if (this.visible == true) {
        this.input_type_pin = "password";
        this.visible = false;
      } else {
        this.input_type_pin = "number";
        this.visible = true;
      }
    },
    togglePeekerCon() {
      if (this.con_visible == true) {
        this.input_type_con = "password";
        this.con_visible = false;
      } else {
        this.input_type_con = "number";
        this.con_visible = true;
      }
    },
    getImgSrcCon() {
      return this.con_visible ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
    },
    changeOTP() {
      this.otp_error_message = '';
    },
    validatePIN() {
      let that = this;

      const cookie = that.$cookies;
      let pin_payload = {
        hash: cookie.get('user_session').hash,
        pin: that.pin_value
      }

      that.setLoading(true);
      that.show_message_modal = false;
      User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
        let config = that.$store.state.credentials.config;
        let noContact = that.$store.state.credentials.noContact;

        if (noContact) {
          that.setLoading(false);
          that.show_pin_modal = false;
          that.$cookies.set('validated', true);
        } else {
          if (config && config.status) {
            that.setLoading(true);
            that.requestOTP();
          } else {
            that.setLoading(false);
            that.show_pin_modal = false;
            that.$cookies.set('validated', true);
          }
        }

      }).catch(function (error) {
        if (error.response.status === 403) {
          that.expired = true;
          that.$store.state.logged = false;
          that.setLoading(false);
          that.error = true;
          that.info = false;
          that.warning = false;
          that.success = false;
          that.show_message_modal = true;
          that.modal_message = "Your session has expired. Please log in again.";
        }
        that.setLoading(false);
        that.pin_error_message = error.response.data.message;
        that.otpInputKey++;
        that.pin_value = '';
      });
    },
    requestOTP() {
      this.setLoading(true);
      let that = this;
      that.type = 10;
      that.otp_payload = {
        type: that.type,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
        that.show_otp_modal = true;
        that.show_pin_modal = false;
        that.timerEnabled = true;
        that.resettingPIN = false;
        that.timerCount = 120;

      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.modal_message = "Your session has expired. Please log in again.";
          that.warning = false;
          that.success = false;
          that.info = false;
          that.error = true;
          that.otpInputKey++;
        }
      });
    },
    requestOTPPIN() {
      this.setLoading(true);
      this.pin_error_message = '';
      let that = this;
      that.type = 15;
      that.otp_payload = {
        type: that.type,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
        that.show_otp_modal = true;
        that.show_pin_modal = false;
        that.timerEnabled = true;
        that.timerCount = 120;
        that.resettingPIN = true;

      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.modal_message = "Your session has expired. Please log in again.";
          that.warning = false;
          that.success = false;
          that.info = false;
          that.error = true;
          that.otpInputKey++;
        }
      });
    },
    submitOTP() {
      let that = this;
      that.setLoading(true);
      // const cookie = that.$cookies;
      let payload = {
        otp: that.otp,
        type: that.type,
        pin: that.otpPIN
      }
      OTP.validate(payload).then(function (response) {
        that.setLoading(false);
        that.show_otp_modal = false;
        if (that.resettingPIN) {
          that.forgot_PIN = true;
          that.enroll_pin = '';
          that.con_enroll_pin = '';
          that.otp_token = response.data.data.otp_token;
          that.otp_pin = response.data.data.otp_pin;
        } else {
          that.$cookies.set('validated', true);
        }
      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.warning = false;
          that.$store.state.logged = false;
          that.success = false;
          that.info = false;
          that.setLoading(false);
          that.show_otp_modal = false;
          that.show_message_modal = true;
          that.otp = '';
          that.otpInputKey++;
          that.modal_message = "Your session has expired. Please log in again.";

        } else {
          that.setLoading(false);
          that.otp_error_message = error.response.data.message;
          that.otp = '';
          that.otpInputKey++;
        }
      });
    },
    resendOtp() {
      let that = this;
      that.show_resend_otp = false;
      that.timerEnabled = true;
      that.timerCount = 120;
      that.otp_payload = {
        type: 10,
        mobile: that.$store.state.credentials.mobile,
        email: that.$store.state.credentials.email,
        name: that.$store.state.credentials.first_name + ' ' + that.$store.state.credentials.last_name
      };
      OTP.requestOtp(that.otp_payload).then(function (response) {
        that.setLoading(false);
        let data = response.data.data
        that.otpPIN = data.pin;
        that.otpOTP = data.otp;
      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.error = true;
          that.$store.state.logged = false;
          that.modal_message = "Your session has expired. Please log in again.";
          that.show_otp_modal = false;
        }
        that.modal_message = error.response.data.message;
        that.show_otp_modal = false;
        that.error = true;
        that.show_otp_modal = false;
        that.warning = false;
        that.info = false;
        that.success = false;
        that.setLoading(false);
        that.show_message_modal = true;
      });
    },
    togglePeeker() {
      if (this.pin_type == 'password') {
        this.visible_pin = true;
        this.pin_type = 'number';
      } else {
        this.visible_pin = false;
        this.pin_type = 'password';
      }
    },
    getImgSrc() {
      return this.visible_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
    },
    openContact() {
      this.show_help_modal = false;
      this.$emit('openContact');

    },
    getThumbnail() {
      return 'background-image: url(' + this.image + ');';

    },
    showHelp() {
      this.show_help_modal = true;
    },
    skip() {
      this.show_update = false;
      this.$cookies.set('skipped', true);
    },
    directSettings() {
      this.show_update = false;
      this.$router.push({ name: 'settings' });
      this.$cookies.set('skipped', true);
    },
    formatDate(datetimeStr) {
      if (!datetimeStr) return '';

      const date = new Date(datetimeStr);

      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };

      const timeOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };

      const datePart = date.toLocaleDateString('en-US', dateOptions);
      const timePart = date.toLocaleTimeString('en-US', timeOptions);

      return `${datePart} | ${timePart}`;
    },
    // getGaInfo() {
    //   let that = this;
    //   that.setNavbar();
    //   that.show_timer = false;
    //   that.show_message_modal = false;
    //   SGA.getSGAInfo().then((response) => {
    //     let data = response.data.data;
    //     let store = this.$store.state;

    //     store.sga_config.code = data.code;
    //     store.sga_config.date = data.date;
    //     store.sga_config.title = data.title;
    //     store.sga_config.uuid = data.user.uuid;
    //     store.sga_config.eligible = data.user.can_participate;
    //     store.sga_config.has_voted = data.user.has_participated;
    //     store.sga_config.has_registered = data.user.has_registered;
    //     store.sga_config.schedules.has_started = data.schedules.has_started;
    //     store.sga_config.schedules.has_ended = data.schedules.has_ended;
    //     store.sga_config.schedules.start_date = data.schedules.start_date;
    //     store.sga_config.schedules.end_date = data.schedules.end_date;

    //     // Assign dates to component's data for countdown
    //     that.date_start = store.sga_config.schedules.start_date;
    //     that.date_end = store.sga_config.schedules.end_date;
    //     that.show_timer = true;


    //     // Start countdown
    //     that.setButton();
    //     that.startCountdown();
    //   }).catch((error) => {
    //     this.setLoading(false);
    //     this.error = true;
    //     this.show_message_modal = true;
    //     this.modal_message = error.response.data.message;
    //     if (error.response.status == 403) {
    //       this.expired = true
    //       this.modal_message = "Your session has expired. Please log in again.";
    //       this.$store.state.logged = false;
    //     }
    //   });
    // },
    handlePositiveClick() {
      if (this.expired) {
        this.closed();
      } else if (this.hasVotedLocal || this.hasRegisteredLocal) {
        this.closeandRate();
      } else if (!this.$store.state.credentials.has_pin || this.$store.state.credentials.express) {
        this.$router.push('/user/settings');
      }
      else {
        this.show_message_modal = false;
      }
    },
    restartCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      this.startCountdown();
    },
    startCountdown() {
      const startTime = new Date(this.date_start).getTime();
      const endTime = new Date(this.date_end).getTime();

      if (isNaN(startTime) || isNaN(endTime)) return;

      const updateTimer = () => {
        const now = new Date().getTime();

        // Voting hasn't started yet
        if (
          now < startTime &&
          !this.$store.state.sga_config.schedules.has_started
        ) {
          let distance = startTime - now;
          this.label = "Voting Starts in";
          this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          this.hour = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          this.minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

          this.show_timer = true;

          if (!this.isEligible) {
            this.button_text = "Not entitled to vote";
            this.button_visible = true;
          } else if (this.hasRegistered) {
            this.button_text = "You have already registered";
            this.button_visible = true;
          } else if (this.needsToRegister) {
            this.button_text = "Register";
            this.button_visible = true; // Disabled before voting starts
          } else {
            this.button_text = "Voting has not started yet";
            this.button_visible = true;
          }
          return;
        }

        // Voting ongoing
        if (now >= startTime && now < endTime) {
          let distance = endTime - now;
          this.label = "Voting Ends in";
          this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
          this.hour = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          this.minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (this.hasRegistered) {
            this.button_text = "You have already registered";
            this.button_visible = true;
            return;
          }

          if (this.needsToRegister) {
            this.button_text = "Register";
            this.button_visible = false; // <-- Enable Register button when voting starts
            return;
          }

          if (!this.isEligible) {
            this.button_text = "Not entitled to vote";
            this.button_visible = true;
            return;
          }

          if (this.hasVoted) {
            this.button_text = "You Have Already Voted";
            this.button_visible = true;
          } else {
            this.button_text = "Vote Now";
            this.button_visible = false;
          }
          return;
        }

        // Voting has ended
        this.label = "Voting Ended";
        this.days = this.hour = this.minute = this.seconds = 0;
        this.button_text = "Voting has ended";
        this.button_visible = true;
        this.$store.state.sga_config.schedules.has_ended = true;
        clearInterval(this.countdownInterval);
      };

      updateTimer();
      this.countdownInterval = setInterval(updateTimer, 1000);
    },
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      this.show_menu = false;
      window.scrollTo(0, top);
    },
    remove() {
      this.show_identifier = false;
    },
    OpenTerms() {
      this.$emit('OpenTerms');
    },
    OpenPrivacy() {
      this.$emit('OpenPrivacy');
    },
    closeandRate() {
      this.show_message_modal = false;
      this.rating_modal = true;
    },
    forceLogout() {
      let that = this;
      that.$cookies.remove('user');
      that.$cookies.remove('user_session');
      that.$router.push('/');
    },
    logout() {
      let that = this;
      that.setLoading(true);
    },
    donelogout() {
      let that = this;
      that.setLoading(false);
    },
    handleLogout() {
      const that = this;
      const store = this.$store;
      const cookie = this.$cookies;
      const payload = {
        hash: store.state.credentials.hash
      };
      that.setLoading(true);
      User.logout(payload)
        .then(() => {
          const that = this;
          store.state.logged = false;
          store.state.credentials.hash = '';
          cookie.remove('user');
          cookie.remove('user_session');
          this.$router.push('/');
          that.setLoading(false);
          this.show_message_modal = false;
        })
        .catch(() => {
          const that = this;
          store.state.logged = false;
          store.state.credentials.hash = '';
          this.$emit('donelogout');
          this.$router.push('/');
          that.setLoading(false);
          this.show_message_modal = false;
          this.show_otp_modal = false;
          this.otp = '';
        });
    },
    setButton() {
      let now = new Date(this.server_time).getTime(); // Fixed: getTime() takes no arguments
      let election_start = new Date(this.date_start).getTime();

      // Case 1: Voting has ended
      if (this.voting_ended) {
        this.button_visible = true;
        this.button_text = "VOTING HAS ENDED";
        this.label = "Voting has ended";
        this.show_timer = !this.show_timer;
        return;
      }

      // Case 2: Voting hasn't started yet
      if (election_start > now) {
        if (!this.election_registered) {
          this.button_text = "REGISTER";
          this.button_function = 1;
          this.button_visible = false;
        } else {
          this.button_text = "REGISTERED";
          this.button_visible = true;
        }
        this.label = "Voting starts in";
        this.show_timer = true;
        return;
      }

      // Case 3: Voting has started but not ended
      this.label = "Voting ends in";
      this.show_timer = true;

      if (this.voted) {
        this.button_text = "YOU HAVE ALREADY VOTED";
        this.button_visible = true;
      } else if (this.hasRegistered) {
        this.button_text = "YOU HAVE ALREADY REGISTERED";
        this.button_visible = true;
      } else if (!this.election_registered) {
        this.button_text = "REGISTER";
        this.button_function = 1;
        this.button_visible = false;
      } else if (this.election_registered && this.can_vote) {
        this.button_text = "VOTE NOW";
        this.button_function = 2;
        this.button_visible = false;
      } else {
        this.button_visible = true;
      }
    },

    showMenu() {
      if (this.show_menu) {
        this.hideMenu();
      } else {
        this.show_menu = true;
      }
    },
    hideMenu() {
      this.show_menu = false;
    },
    handlePollVote(vote) {
      this.selectedVote = vote;
      this.show_confirm_modal = true;
    },
    vote(n) {
      let that = this;

      let store = that.$store.state.credentials;
      let hash = store.hash;
      let key = store.key;
      let value = n;
      that.button_visible = false;

      that.voted = true;
      that.setLoading(true);
      that.show_poll_modal = false;
      that.show_confirm_modal = false;
      SGA.pollVote(hash, value, key).then(function () {
        that.success = true;
        that.error = false;
        that.hasVotedLocal = true;
        that.expired = false;
        that.modal_message = 'Your vote has been successfully recorded. Thank you for participating!';
        that.show_message_modal = true;
        that.setLoading(false);
        that.setButton();
      }).catch(function (error) {
        if (error.response.status == 403) {
          that.expired = true;
          that.$store.state.logged = false;
          that.error = true;
          that.modal_message = "Your session has expired. Please log in again.";
        } else {
          that.error = true;
          that.modal_message = error.response.data.message;
        }
        that.setLoading(false);
        that.show_message_modal = true;

      });

    },
    click() {
      let that = this;
      let store = that.$store;
      let state = store.state;

      if (that.button_function == 1) {
        that.show_confirm_register = true;
      }
      if (that.button_function == 2) {
        // that.showPollModal();
        state.user.skip = false;
        that.setLoading(true);
        that.$router.push("/election/voting");

        // that.setButton();
      }

    },
    requestOtp() {
      let that = this;
      const store = that.$store;
      const state = store.state;
      var payload = {
        email: state.credentials.email,
        mobile: state.credentials.mobile,
        name: state.credentials.first_name,
        pin: state.credentials.pin,
        type: 5
      }
      that.setLoading(true);
      OTP.requestOtp(payload).then(function (response) {
        var request_otp = response.data.data;
        state.credentials.otp = request_otp.otp;
        state.credentials.pin = request_otp.pin;
        that.setLoading(false);
      }).catch(function (response) {
        that.setLoading(false);
        that.button_visible = true;
        that.voted = true;
        that.error = true;
        that.show_message_modal = true;
        that.modal_message = response.data.message;
      });

    },
    setNavbar() {
      let that = this;
      const store = that.$store;
      let state = store.state.credentials;

      that.name = state.username;
    },
    showAmendments() {
      this.show_pdf = true;
    },
    showPollModal() {
      this.show_poll_modal = true;
    },
    showScheduleModal() {
      this.schedule_modal = true;
    },
    closedPoll() {
      this.show_poll_modal = false;
    },
    closed() {
      let that = this;
      // let store = that.$store;
      // let state = store.state;
      // if (that.expired) {
      that.$cookies.remove('user');
      that.$cookies.remove('user_session');
      that.$router.push('/');
      // }
      // if (!state.credentials.has_pin) {
      //   that.$cookies.remove('user');
      //   that.$cookies.remove('user_session');
      //   that.$router.push('/user/settings');
      // }
      that.show_message_modal = false;
    },
    closedAmendments() {
      this.show_pdf = false;
    },
    closePdf() {
      this.show_pdf = false;
    },
  },
  beforeUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }



})
</script>
<style scoped>
.modal_max_width {
  max-width: 200px;
}

.contact-w {
  width: 100px !important;
  min-width: 120px !important;
}

.strip-banner {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.timer {
  margin: auto !important;
}

.banner-size-md {
  height: 500px;
}

.banner-size-sm {
  height: 180px;
}
</style>
